const JUNK_ONLY_PARAMS = [
  "payment_id",
  "subscription_id",
  "email",
  "license_key",
  "status",
];

const CONFIRM_TOKEN = /^[a-f0-9]{48}$/i;

function locationParts(url) {
  return { u: new URL(url) };
}

function confirmTokenFromHash(hash) {
  if (!hash) return null;
  const path = hash.match(/^#\/confirm\/([a-f0-9]{48})/i);
  if (path) return path[1];
  const eq = hash.match(/confirm=([a-f0-9]{48})/i);
  return eq ? eq[1] : null;
}

/** Dodo may replace the query string; the token lives in search or in `#/confirm/<48 hex>`. */
export function readCheckoutReturnId(url) {
  try {
    const u = new URL(url);
    const sid = u.searchParams.get("session_id");
    if (sid) return sid;
    const q = u.searchParams.get("confirm");
    if (q && CONFIRM_TOKEN.test(q)) return q;
    return confirmTokenFromHash(u.hash);
  } catch {
    return null;
  }
}

function hashIsConfirm(hash) {
  return Boolean(confirmTokenFromHash(hash));
}

// Strips only the truly-junk Dodo params on board mount. Leaves confirm/session_id
// and `#/confirm/…` for the Confirmation lifecycle to handle.
export function stripJunkParams(url) {
  try {
    const { u } = locationParts(url);
    let changed = false;
    for (const key of JUNK_ONLY_PARAMS) {
      if (u.searchParams.has(key)) {
        u.searchParams.delete(key);
        changed = true;
      }
    }
    return { url: u.pathname + u.search + u.hash, changed };
  } catch {
    return { url: url, changed: false };
  }
}

const CHECKOUT_RETURN_JUNK = [
  ...JUNK_ONLY_PARAMS,
  "confirm",
  "session_id",
];

// Strips all checkout return params including lifecycle + confirm hash.
export function stripCheckoutReturnParams(url) {
  try {
    const { u } = locationParts(url);
    let changed = false;
    for (const key of CHECKOUT_RETURN_JUNK) {
      if (u.searchParams.has(key)) {
        u.searchParams.delete(key);
        changed = true;
      }
    }
    if (hashIsConfirm(u.hash)) {
      u.hash = "";
      changed = true;
    }
    return { url: u.pathname + u.search + u.hash, changed };
  } catch {
    return { url: url, changed: false };
  }
}
